/* ThaBel — busca de avaliações no Air Reviews (a mesma fonte do widget do app).
   Permite filtrar por nota e carregar todas as avaliações, não só as 10 que vêm no tema.
   Se o Air Reviews não responder, a página continua mostrando as avaliações que já vieram no HTML. */
(function () {
  if (window.TbAv) return;
  var BASE = 'https://app.airreviews.io/review/loadReviews';

  function pagina(p) {
    var q = new URLSearchParams({ shopId: p.shopId });
    if (p.productId) q.set('productId', p.productId);
    if (p.sort) q.set('sort', p.sort);
    if (p.min) q.set('minimumRating', p.min);
    if (p.after) q.set('after', p.after);
    var ctrl = typeof AbortController === 'function' ? new AbortController() : null;
    var t = ctrl && setTimeout(function () { ctrl.abort(); }, 10000);
    return fetch(BASE + '?' + q.toString(), ctrl ? { signal: ctrl.signal } : undefined).then(function (r) {
      if (t) clearTimeout(t);
      if (!r.ok) throw new Error('air');
      return r.json();
    }).then(function (j) {
      var d = (j && j.data) || {};
      return { lista: d.reviews || [], mais: !!d.hasNext };
    });
  }

  /* Fonte de avaliações com filtro. opts: { shopId, productId?, nota? (1..5), fotos? } */
  function fonte(opts) {
    var after = null, acabou = false, vistos = {};
    var nota = opts.nota ? parseInt(opts.nota, 10) : null;
    var sort = nota && nota < 5 ? 'rate_asc' : null;
    return {
      acabou: function () { return acabou; },
      pular: function (ids) { (ids || []).forEach(function (id) { vistos[id] = 1; }); },
      comecarDepois: function (id) { after = id; },
      proximos: async function (qtd) {
        var out = [], voltas = 0;
        while (out.length < qtd && !acabou && voltas < 40) {
          voltas++;
          var res = await pagina({ shopId: opts.shopId, productId: opts.productId, sort: sort, min: nota, after: after });
          if (!res.lista.length) { acabou = true; break; }
          after = res.lista[res.lista.length - 1].id;
          for (var i = 0; i < res.lista.length; i++) {
            var r = res.lista[i];
            if (vistos[r.id]) continue;
            vistos[r.id] = 1;
            if (r.status && r.status !== 'approved') continue;
            if (nota && r.rate !== nota) {
              if (nota < 5 && r.rate > nota) { acabou = true; break; }
              continue;
            }
            if (opts.fotos && !(r.images && r.images.length)) continue;
            out.push(r);
          }
          if (!res.mais) acabou = true;
        }
        return out;
      }
    };
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }
  function nomeCurto(r) {
    var bruto = String(r.firstName || r.first_name || 'Cliente').trim();
    var p = bruto.split(/\s+/);
    var nome = p[0].charAt(0).toUpperCase() + p[0].slice(1).toLowerCase();
    var sob = r.lastName || p[1] || '';
    return sob ? nome + ' ' + sob.charAt(0).toUpperCase() + '.' : nome;
  }
  function estrelas(n) {
    n = Math.max(0, Math.min(5, Number(n) || 0));
    return '<span class="tb-estrelas" style="--p: ' + (n * 20) + '%;" aria-hidden="true">★★★★★</span><span class="tb-sr">Nota ' + n + ' de 5</span>';
  }
  /* Só aceita endereços http(s) ou relativos — nunca javascript:/data: vindos de fora */
  function urlSegura(u) {
    u = String(u || '').trim();
    return /^(https?:)?\/\//i.test(u) || /^\/[^/]/.test(u) ? u : '';
  }
  /* Foto de avaliação em tamanho reduzido quando vier da CDN da Shopify (evita baixar o original) */
  function redimensionar(u, tam) {
    if (!/cdn\.shopify\.com|shopifycdn/.test(u)) return u;
    try { var o = new URL(u); o.searchParams.set('width', String(tam * 2)); return o.toString(); } catch (e) { return u; }
  }
  function fotos(r, grupo, tam) {
    if (!r.images || !r.images.length) return '';
    var nome = esc(nomeCurto(r));
    var g = esc(grupo);
    return r.images.slice(0, 4).map(function (img) {
      var bruto = urlSegura(typeof img === 'string' ? img : (img && (img.url || img.src)) || '');
      if (!bruto) return '';
      var href = esc(bruto), src = esc(redimensionar(bruto, tam));
      return '<a href="' + href + '" data-tb-foto="' + g + '"><img src="' + src + '" alt="Foto enviada por ' + nome + '" width="' + tam + '" height="' + tam + '" loading="lazy" decoding="async"></a>';
    }).join('');
  }
  function texto(r) { return esc(r.content).replace(/\n/g, '<br>'); }

  window.TbAv = { fonte: fonte, esc: esc, urlSegura: urlSegura, nomeCurto: nomeCurto, estrelas: estrelas, fotos: fotos, texto: texto };
})();
